import styles from './BackButton.module.scss'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowBackIcon } from '@/shared/icons'

export const BackButton = () => {
  const { t } = useTranslation('main')

  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  };

  return (
    <div className={styles.wrapper}
      onClick={handleGoBack}>
      <ArrowBackIcon />
      {t('back')}
    </div>
  )
}
